<template>
  <div>
    <affiliate-media-kit-pop-up
      :affiliateData="'affiliate' in affiliateData ? affiliateData.affiliate : affiliateData"
      v-on:update_media_kit="onUpdateMediaKit"
    />
    <AffiliateFormChangeEmail
      @updateInputLogin="affiliateData.email = $event"
      @closeDialog="changeEmailDialog = false"
      :changeEmailDialog="changeEmailDialog"
      :affiliateId="affiliateData?.id"
    />
    <q-card flat>
      <q-card-section class="row q-col-gutter-md">
        <div class="col-4">
          <q-avatar size="96px" font-size="96px" text-color="grey-5">
            <img :src="getGravatar(affiliateData?.email)" />
          </q-avatar>
        </div>
        <div class="col-5">
          <div class="text-h6">{{ $t('access_data') }}</div>
        </div>
      </q-card-section>
    </q-card>
    <q-card flat>
      <q-card-section class="row q-col-gutter-md">
        <div class="col-6">
          <q-input v-model="affiliateData.email" outlined readonly type="text" label="Login">
            <template v-if="affiliateData?.id" v-slot:append>
              <q-btn
                color="primary"
                no-caps
                unelevated
                icon="mdi-pencil-outline"
                @click="() => (changeEmailDialog = true)"
              />
            </template>
          </q-input>
        </div>

        <div class="col-6">
          <q-input v-if="affiliateData?.id" outlined readonly type="text" v-model="affiliateData.id" label="ID">
            <template v-slot:append>
              <q-btn color="primary" no-caps unelevated icon="mdi-content-copy" @click="copyData(affiliateData.id)">
                <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                  {{ $t('copy') }}
                </q-tooltip>
              </q-btn>
            </template>
          </q-input>
          <q-input v-else outlined readonly type="text" v-model="affiliateData.affiliate.id" label="ID">
            <template v-slot:append>
              <q-btn
                color="primary"
                no-caps
                unelevated
                icon="mdi-content-copy"
                @click="copyData(affiliateData.affiliate?.id)"
              >
                <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                  {{ $t('copy') }}
                </q-tooltip>
              </q-btn>
            </template>
          </q-input>
        </div>

        <div class="col-6">
          <q-input v-if="affiliateData.token" outlined readonly type="text" v-model="affiliateData.token" label="Token">
            <template v-slot:append>
              <q-btn color="primary" no-caps unelevated icon="mdi-content-copy" @click="copyData(affiliateData.token)">
                <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                  {{ $t('copy') }}
                </q-tooltip>
              </q-btn>
            </template>
          </q-input>
          <q-input v-else outlined readonly type="text" v-model="affiliateData.affiliate.token" label="Token">
            <template v-slot:append>
              <q-btn
                color="primary"
                no-caps
                unelevated
                icon="mdi-content-copy"
                @click="copyData(affiliateData.affiliate.token)"
              >
                <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
                  {{ $t('copy') }}
                </q-tooltip>
              </q-btn>
            </template>
          </q-input>
        </div>
        <div class="col-6">
          <q-input outlined readonly class="q-pa-none justify-center">
            <template v-slot:default>
              <div class="relative-position" style="width: 100%">
                <q-btn
                  v-if="user.profile == 'afiliado' && affiliateData.affiliate.media_kit == null"
                  unelevated
                  flat
                  class="absolute"
                  style="left: -35%; top: 20%"
                  @click="triggerUpload"
                >
                  <div class="row items-center no-wrap">
                    <q-icon name="cloud_upload" size="28px" class="q-mr-sm" />
                    <span class="text-subtitle1">{{ $t('upload_media_kit') }}</span>
                  </div>
                </q-btn>
                <q-btn
                  v-else-if="affiliateData.media_kit || affiliateData.affiliate.media_kit"
                  unelevated
                  flat
                  class="absolute"
                  style="left: -35%; top: 20%"
                  @click="ActionSetDialogMediaKit(true)"
                >
                  <div class="row items-center no-wrap">
                    <q-icon name="cloud_upload" size="28px" class="q-mr-sm" />
                    <span class="text-subtitle1">{{ $t('view_media_kit') }}</span>
                  </div>
                </q-btn>
              </div>
            </template>
          </q-input>
          <input
            ref="fileInput"
            type="file"
            class="hidden"
            @change="onFileChange"
            accept=".pdf, .ppt, .pptx, .png, .jpg, .jpeg"
          />
        </div>
      </q-card-section>

      <q-card-actions class="q-mt-md" align="right">
        <q-btn
          v-if="isMainAffiliate()"
          color="negative"
          no-caps
          :label="$t('delete_account')"
          class="q-px-md"
          unelevated
          @click="exclusionDialog = true"
        />

        <q-btn
          v-else-if="user.profile != 'afiliado'"
          color="negative"
          no-caps
          :label="$t('approve_account_deletion')"
          class="q-px-md"
          unelevated
          @click="exclusionDialog = true"
        />

        <q-btn
          color="primary"
          no-caps
          :label="$t('reset_password')"
          class="q-px-md"
          unelevated
          @click="passwordDialog = true"
        />
        <!-- <q-btn
                    color="primary"
                    no-caps
                    label="Redefinir Email"
                    class="q-px-md"
                    unelevated
                    @click="emailDialog = !emailDialog"
                /> -->
      </q-card-actions>
    </q-card>

    <q-card flat class="q-mt-lg" v-if="isMainAffiliate()">
      <q-form @submit.prevent="createNewAccess">
        <q-card-section class="row q-col-gutter-md">
          <div class="col-12 text-h6 text-center">{{ $t('create_new_access') }}</div>
          <div class="col-6">
            <q-input
              outlined
              v-model="newAccess.name"
              ref="newAccessNameInputRef"
              :label="$t('name') + '*'"
              lazy-rules
              :rules="[isRequired]"
            >
            </q-input>
          </div>
          <div class="col-6">
            <q-input
              outlined
              type="email"
              ref="newAccessEmailInputRef"
              v-model="newAccess.email"
              label="Email *"
              lazy-rules
              :rules="[isRequired, isEmail]"
            >
            </q-input>
          </div>
        </q-card-section>
        <q-card-actions class="q-mt-md" align="right">
          <q-btn color="positive" no-caps :label="$t('create')" class="q-px-md" unelevate type="submit" />
        </q-card-actions>
      </q-form>
    </q-card>
    <q-dialog v-model="deleteAccessDialog.show">
      <q-card class="q-pa-lg">
        <div class="text-h5 q-mb-lg">{{ $t('confirm_delete_access') }}</div>
        <div class="flex justify-around">
          <q-btn color="primary" @click="deleteAccess(deleteAccessDialog.user_id)">{{ $t('confirm') }}</q-btn>
          <q-btn color="negative" @click="deleteAccessDialog = { show: false, user_id: null }">{{
            $t('cancel')
          }}</q-btn>
        </div>
      </q-card>
    </q-dialog>

    <q-card flat v-if="isMainAffiliate() && affiliateAccess.length > 1">
      <q-card-section>
        <div class="col-12 text-h6 text-center">{{ $t('secondary_access') }}:</div>
        <div class="row col-12" v-for="(user, index) in affiliateAccess" :key="index">
          <q-input
            v-if="index > 0"
            class="col-6 q-pr-md"
            outlined
            v-model="user.name"
            type="text"
            :label="$t('name') + '*'"
            lazy-rules
            :rules="[isRequired]"
            :readonly="!!affiliateAccess[index].id"
          />
          <q-input
            v-if="index > 0"
            class="col-6"
            outlined
            v-model="user.email"
            type="text"
            label="Email *"
            lazy-rules
            :rules="[isRequired, isEmail]"
            :readonly="!!affiliateAccess[index].id"
          >
            <template v-slot:after>
              <q-btn
                class="q-py-sm"
                unelevated
                clearable
                clear-icon="mdi-close"
                color="negative"
                icon="mdi-close"
                @click="deleteAccessDialog = { show: true, user_id: user.id }"
              />
            </template>
          </q-input>
        </div>
      </q-card-section>
    </q-card>

    <q-dialog v-model="exclusionDialog">
      <AffiliateAccountExclusionModal
        v-if="isMainAffiliate()"
        @goToPayment="$emit('goToPayment')"
        v-on:close-popup="exclusionDialog = false"
      />
      <affiliate-account-exclusion-approval-modal
        :affiliateId="affiliateData.id"
        v-else-if="user.profile != 'afiliado'"
        v-on:close-popup="exclusionDialog = false"
      />
    </q-dialog>

    <q-dialog v-model="passwordDialog" persistent ref="dialogPassword">
      <affiliate-form-change-password
        v-on:close-popup="passwordDialog = false"
        :email="affiliateData?.email"
        :id="this.id"
      />
    </q-dialog>
    <AffiliateContentModelUpdateEmail
      @reloadDialog="setupAffiliateData"
      :affiliate-id="id"
      :showDialogEmail="emailDialog"
    />
  </div>
</template>

<script>
import AffiliateService from '../../../services/AffiliateService';
import AffiliateMixin from '../../../mixins/AffiliateMixin';
import AffiliateContentModelUpdateEmail from '@c/affiliate/affiliateContent/AffiliateContentModelUpdateEmail';
import AffiliateFormChangeEmail from './AffiliateFormChangeEmail.vue';
import AffiliateFormChangePassword from './AffiliateFormChangePassword.vue';
import AffiliateAccountExclusionModal from './account/AffiliateAccountExclusionModal.vue';
import AffiliateAccountExclusionApprovalModal from './account/AffiliateAccountExclusionApprovalModal.vue';
import AffiliateMediaKitPopUp from './AffiliateMediaKitPopUp.vue';
import md5 from 'crypto-js/md5';

export default {
  props: {
    id: {
      type: [String, Number],
      require: true
    },
    affiliateData: { type: Object }
  },
  mixins: [AffiliateService, AffiliateMixin],
  components: {
    AffiliateContentModelUpdateEmail,
    AffiliateFormChangeEmail,
    AffiliateFormChangePassword,
    AffiliateAccountExclusionModal,
    AffiliateAccountExclusionApprovalModal,
    AffiliateMediaKitPopUp
  },
  name: 'AffiliateContentAccess',
  data() {
    return {
      emailDialog: false,
      changeEmailDialog: false,
      passwordDialog: false,
      exclusionDialog: false,
      newAccess: {},
      affiliateAccess: [],
      deleteAccessDialog: { show: false, user_id: null },
      login: null
    };
  },
  methods: {
    getGravatar(emailAddress) {
      let convertEmailAddress = md5(emailAddress);
      return `https://www.gravatar.com/avatar/${convertEmailAddress}`;
    },

    triggerUpload() {
      this.$refs.fileInput.click();
    },

    async onFileChange(event) {
      const file = event.target.files[0];
      const renameTo = `mediakit_affiliate_${this.user.user_id}_${this.$moment().format(
        'YYYY-MM-DD'
      )}_${this.uuidV4()}`;
      if (file) {
        let form = new FormData();
        form.append('file', file);
        form.append('file_rename', renameTo);
        form.append('bucket', 's3AffiliateMediaKit');

        try {
          this.onLoading(true);
          const { status } = await this.uploadFile(form);
          if (status == 200) {
            await this.editAffiliateData(this.id, { media_kit: renameTo, media_kit_type: file.type });
            this.successNotify('media_kit_upload_successfull');
            // await this.setupAffiliateData();
            this.affiliateData.affiliate.media_kit = renameTo;
            this.affiliateData.affiliate.media_kit_type = file.type;
          }
        } catch (error) {
          this.errorNotify(error);
        } finally {
          this.onLoading(false);
        }
      }
    },
    async setupAffiliateData() {
      this.onLoading(true);
      try {
        const { data, status } = await this.getAffiliateData(this.id);
        if (status === 200) this.affiliateData = data;
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },
    async onSave() {
      this.onLoading(true);
      try {
        this.affiliateData.zip_code = this.affiliateData.zip_code.replace(/\D/g, '');
        const { status } = await this.editAffiliateData(this.id, this.affiliateData);
        if (status === 200) {
          this.passwordDialog = false;
          this.successNotif(this.$t('data_updated_successfully'));
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.$refs.dialogPassword.hide();
        this.onLoading(false);
      }
    },

    async retrieveAccess() {
      try {
        this.onLoading(true);
        const { data, status } = await this.$http.get('/v2/affiliate/settings/users');

        if (status == 200) {
          this.affiliateAccess = data;
        }
      } catch (error) {
        if (error.response.status != 403) {
          if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
          else this.errorNotify(error);
        }
      } finally {
        this.onLoading(false);
      }
    },

    isMainAffiliate() {
      return this.affiliateAccess[0] != undefined && this.affiliateData?.email == this.affiliateAccess[0]?.email;
    },

    async createNewAccess() {
      try {
        this.onLoading(true);
        const { data, status } = await this.createNewAffiliateAccess(this.newAccess);
        if (status == 201) {
          this.successNotify(data.message);
          this.retrieveAccess();
          this.newAccess = {};
          this.$refs.newAccessEmailInputRef.resetValidation();
          this.$refs.newAccessNameInputRef.resetValidation();
        }
      } catch (error) {
        if ('email' in error.response.data) {
          this.errorNotify(error.response.data?.email[0]);
        } else {
          if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
          else this.errorNotify(error);
        }
      } finally {
        this.onLoading(false);
      }
    },

    async deleteAccess(id) {
      try {
        this.onLoading(true);
        const { data, status } = await this.deleteAffiliateAccess(id);
        if (status == 200) {
          this.successNotify(data.message);
          this.retrieveAccess();
          this.deleteAccessDialog = { show: false, user_id: null };
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    onUpdateMediaKit(media) {
      console.log(media);
      this.affiliateData.affiliate.media_kit = media.media_kit;
      this.affiliateData.affiliate.media_kit_type = media.media_kit_type;
    }
  },
  created() {
    // console.log(this.affiliateData);
    this.retrieveAccess();
  }
};
</script>

<style>
.hidden {
  display: none;
}
</style>
